const Currency = '$'
export const formatAmount = (amount) => {
    if (isNaN(amount))
        return 0;
    let value = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    return `${Currency}${value}`
    
    
}

export const formatPrice = (value) => {
    // Allow only digits and a single dot
    let sanitizedValue = value.replace(/[^\d.]/g, "");
  
    // Prevent more than one dot in the input
    if (sanitizedValue.indexOf(".") !== sanitizedValue.lastIndexOf(".")) {
      sanitizedValue = sanitizedValue.slice(0, -1);
    }
  
    // Format to two decimal places (conditionally when user pauses typing)
    const formattedValue = sanitizedValue
      .split(".")
      .map((part, index) => (index === 1 ? part.slice(0, 2) : part)) // Keep only 2 decimal places
      .join(".");
      return formattedValue;
  };

  export const addTrailingZeros = (value) => {
    if (!value) return "0.00"; // Default value if empty
    let formattedValue = value.toString().includes(".") ? parseFloat(value).toFixed(2) : `${value}.00`;
    return formattedValue;
  };

  export const formatInvoiceNo = (invoiceNo, format = "INV") => {
    invoiceNo = invoiceNo.toString().padStart(6, "0");
    return `${format}${invoiceNo}`
  }
